module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mask-white-dialog"
  }, [_c('div', {
    staticClass: "m-toast",
    class: _vm.iconsClass == '' ? 'toast-none-icon' : ''
  }, [(_vm.iconsClass) ? _c('div', {
    class: _vm.iconsClass
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "toast-content",
    domProps: {
      "innerHTML": _vm._s(_vm.mes)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-327da59c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dialog/toast/ToastTpl.vue
// module id = 599
// module chunks = 1